import React from "react";

function Footer() {
  return (
    <footer>
      <div className="social-links">
        <a href="https://facebook.com" target="_blank" rel="noopener">
          Facebook
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener">
          Instagram
        </a>
      </div>
      <p>© 2024 Qdamos. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;
